import React, {useRef, useEffect, useState, Fragment} from "react";
import styled from "styled-components";
import Modal from "components/ui/Modal";
import Button from "./Button";
import iconClose from "assets/icons/icon_close_black.svg";
import iconQuestion from "assets/icons/icon_tooltip_gray.svg";

export const Tooltip = ({title, content}) => {
	const eventHandler = {
		open : () => {
			Modal(
				<StyledDiv>
					<div className="head">
						{title}
						<a onClick={eventHandler.close} />
					</div>
					<div className="body">
						{content}
					</div>
				</StyledDiv>
			, true);
		},
		close : () => {
			Modal();
		}
	};

	return (<Wrapper onClick={eventHandler.open} />);
};

const Wrapper = styled.div`
&				{display:inline-flex; vertical-align:text-bottom; align-items:center; justify-content:center;
				 margin:0 5px; width:1.125em; height:1.125em; 
				 background:url(${iconQuestion}) no-repeat center center / 1.125em; border-radius:100%}
`;

const StyledDiv = styled.div`
&				{position:relative; padding:20px; width:auto !important; max-width:85%}
& > .head		{margin-bottom:10px; line-height:1.2; font-size:var(--15px); font-weight:bold}
& > .head > a	{position:absolute; right:18px; top:18px; width:24px; height:24px; background:url(${iconClose}) no-repeat center center / 20px}

`;

export default Tooltip;